import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { Label, Alert } from '../default'
import { Box, Grid, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { RegisterCustomerForm } from '../forms'


function RegisterCustomerModal({
  classes, open, onClose, createdPlanTableError
}) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
      <Paper
        square={true}
        className={classes.root + ' ' + classes.modalDiv}
      >
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Grid container spacing={2} className={classes.grid}>
            <Grid item xs={8}>
              <Label v='h6'>
                {t('modals.customer.register.title')}
              </Label>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right', padding: 0 }}>
              <Tooltip title={t('default.close')}>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={12}>
              <RegisterCustomerForm onSubmit={() => onClose()} />
            </Grid>
          </Grid>
        </Box>

        <div style={{ marginTop: '15px' }}>
          {
            createdPlanTableError &&
            (createdPlanTableError.description ? (
              <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={createdPlanTableError.description} />
            ) : createdPlanTableError.errors ? (
              <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={t('modals.planTable.create.unknownError')} />
            ) : null)
          }
        </div>
      </Paper>
    </Modal >
  )
}

RegisterCustomerModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  close: PropTypes.func
}

RegisterCustomerModal.defaultProps = {
  open: false,
  onClose: () => true,
  close: () => true
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    padding: theme.spacing(2),
    maxHeight: '90%',
    overflowY: 'scroll'
  },
  grid: {
    display: 'flex',
    flex: 1
  },
  modalDiv: {
    [theme.breakpoints.up('md')]: {
      width: '35%'
    },
    width: '100%',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -10%)',
  }
})

const mapStateToProps = ({ ReducerPlanTable }) => ({
  cachedPlanTable: ReducerPlanTable.cachedPlanTable,
  creatingPlanTable: ReducerPlanTable.creatingPlanTable,
  createdPlanTableError: ReducerPlanTable.createdPlanTableError
})

export default connect(mapStateToProps)(withStyles(styles)(RegisterCustomerModal))